module.exports = __webpack_public_path__ + "static/media/nextjs.661bf872.png";